import './App.css';
import AppRoutes from './routes';


function App() {
  return (
    <div className="App bg-[#F6F6F6] h-screen ">
      <AppRoutes />
    </div>
  );
}

export default App;
